// components/CustomerSegmentChart.jsx
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const CustomerSegmentChart = () => {
  const data = {
    labels: ['New Customers', 'Repeat Customers', 'High-Spenders', 'Discount Seekers'],
    datasets: [
      {
        label: 'Customer Segments',
        data: [35, 30, 20, 15],
        backgroundColor: [
          '#4f46e5',
          '#8b5cf6',
          '#a78bfa',
          '#ddd6fe',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    cutout: '70%',
    plugins: {
      legend: {
        position: 'right',
        labels: {
          usePointStyle: true,
        },
      },
    },
  };

  return <Doughnut data={data} options={options} height={250} />;
};

export default CustomerSegmentChart;
